import moment from 'moment'
import localforage from 'localforage'

class Security {
    // LOGIN REQUEST
    login(email, password, callback) {
        axios
            .post(
                urlAPI + '/oauth/v2/token',
                {
                    username: email,
                    password: password,
                    grant_type: 'password',
                    client_id: '1_3bcbxd9e24g0gk4swg0kwgcwg4o8k8g4g888kwc44gcc0gwwk4',
                    client_secret: '4ok2x70rlfokc8g0wws8c8kwcokw80k44sg48goc0ok4w0so0k'
                }
            ).then(function (response) {
            if (response.data.access_token && response.data.token_type) {
                localStorage.setItem('pwd', password);
                localStorage.setItem('email', email);
                callback({'status': true, 'apiKey': response.data.access_token});
            }
        })
            .catch(function (error) {
                const desc = error.response.data.error_description;
                const err =  ( desc === 'Invalid username and password combination') ? 'Mauvaise combinaison Login / Mot de passe' : desc;

                callback({'status': false, 'error': err});
            });
    }

    // LOGOUT FUNCTION
    logout(callback) {
        localforage
            .removeItem('api-token')
            .then(function () {
                localforage
                    .removeItem('lastConnexion')
                    .then(function () {
                        callback('ok');
                    })
                    .catch(function () {
                        callback('ko');
                    });

            })
            .catch(function () {
                callback('ko');
            });
    }

    // CHECK SESSION
    isLogged(callback) {
        localforage
            .getItem('lastConnexion')
            .then(function (value) {
                if (value == null) {
                    callback(false);
                } else {
                    var endSession = moment(value).add(12, 'hours');
                    if (endSession.isBefore(moment())) {
                        callback(false);
                    } else {
                        callback(true);
                    }
                }
            })
            .catch(function() {
                callback(false);
            });
    }

    // TRIGGER WHEN LOGIN FUNCTION IS SUCCESSFUL
    setUserSession(apiKey, callback) {
        let now = moment().format();

        localforage
            .setItem('lastConnexion', now)
            .then(function() {

                localforage
                    .setItem('api-token', apiKey)
                    .then(function() {
                        callback({status: true})
                    })
                    .catch(function (err) {
                        callback({status: false, error: err})
                    });

            })
            .catch(function (err) {
                callback({status: false, error: err})
            });
    }
}

export default Security



// WEBPACK FOOTER //
// ./src/js/core/Security.js